const renderCanvas = (canvas, fruit, sandwich, dessert, note) => {
  const LUNCHBOX_W = document.getElementsByClassName('container')[0].clientWidth,
        LUNCHBOX_H = LUNCHBOX_W * 1.35,
        PADDING = LUNCHBOX_W / 15

  const noteConfig = {
    width: LUNCHBOX_W / 1.75,
    height: (LUNCHBOX_H / 3),
    lineHeight: 52,
    font: '38pt professor, sans-serif',
    maxWidth: (LUNCHBOX_W / 1.75) - PADDING,
    maxHeight: ((LUNCHBOX_W / 1.75) * .7) - PADDING,
    x: LUNCHBOX_W / 2,
    y: PADDING * 4.25
  }

  const sandwichConfig = {
    width: LUNCHBOX_W / 2,
    height: LUNCHBOX_W / 2
  }
  const bonusConfig = {
    width: LUNCHBOX_W / 4,
    height: LUNCHBOX_W / 4
  }

  const ctx = canvas.getContext("2d");

  const drawLunchBox = (ctx) => {
    let { font, maxWidth, maxHeight, lineHeight, x, y } = noteConfig;
    
    // empty lunchbox
    ctx.drawImage(lunchBoxImages['lunchbox-blank.png'], 0, 0, LUNCHBOX_W, LUNCHBOX_H);
    // draw sandwich
    ctx.drawImage(lunchBoxImages[`${sandwich}.png`], PADDING, (LUNCHBOX_H / 2) + PADDING, sandwichConfig.width, sandwichConfig.height);
    // draw fruit
    ctx.drawImage(lunchBoxImages[`${fruit}.png`], (LUNCHBOX_W / 2) + PADDING, (LUNCHBOX_H / 2) + (PADDING * 1.5), bonusConfig.width, bonusConfig.height);
    // draw dessert
    ctx.drawImage(lunchBoxImages[`${dessert}.png`], (LUNCHBOX_W / 2) + (PADDING * 1.5), (LUNCHBOX_H - bonusConfig.height) - PADDING, bonusConfig.width, bonusConfig.height);
    
    // add note
    if (note) {
      ctx.drawImage(lunchBoxImages['note.png'], (LUNCHBOX_W / 2) - (noteConfig.width / 2), PADDING * 3, noteConfig.width, noteConfig.height);
      ctx.font = noteConfig.font;
      console.log(ctx.font)
      ctx.textAlign = "center";

      let noteHeight = calculateHeight({ctx, text: note, maxWidth, lineHeight});
      while (noteHeight > maxHeight) {
        lineHeight--;
        const fontSize = parseInt(font.match(/\d+/));
        font = font.replace(/\d+/, (fontSize - 1));
        ctx.font = font;
        noteHeight = calculateHeight({ctx, text: note, maxWidth, lineHeight});
      }

      y += Math.floor((maxHeight - noteHeight) / 2);
      const { width: noteWidth } = ctx.measureText(note);

      // check if the string is longer than the box and display multiple lines if necessary
      if(noteWidth > maxWidth) {
        wrapText(ctx, note, { x, y, maxWidth, lineHeight });
      } else {
        console.log(ctx.font)
        ctx.fillText(note, x, y);
      }
    }

    ctx.restore();
  }

  ctx.clearRect(0, 0, LUNCHBOX_W, LUNCHBOX_H);
  canvas.width = LUNCHBOX_W;
  canvas.height = LUNCHBOX_H;

  drawLunchBox(ctx);

  ctx.save();
}